import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-marketing-section-heading',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (title || subtitle || eyebrow) {
      <header class="cg-mkt-section__head">
        @if (eyebrow) {
          <span class="cg-mkt-eyebrow">{{ eyebrow }}</span>
        }
        @if (title) {
          <h2>{{ title }}</h2>
        }
        @if (subtitle) {
          <p>{{ subtitle }}</p>
        }
      </header>
    }
  `,
})
export class MarketingSectionHeadingComponent {
  @Input() eyebrow?: string;
  @Input() title?: string;
  @Input() subtitle?: string;
}
